import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";
import { MY_TABS } from "@/components/my/tabs";

function Home({ me, reload }) {
  const { checkAuth } = useAuth();
  const [token, setToken] = useState("");
  const accept = () => api.post("/my/workplaces/accept", { token }).then(() => { toast.success("Workplace connected"); setToken(""); reload(); checkAuth(); }).catch((e) => toast.error(e.response?.data?.detail || "Could not accept"));
  const open = (m) => api.post("/my/session/workplace", { membership_id: m.membership_id }).then(() => { window.location.href = "/dashboard"; });
  return (
    <div className="space-y-4" data-testid="my-home">
      <div className="rounded-2xl border bg-white p-4">
        <div className="text-sm text-slate-500">Your CaterCTRL account belongs to you.</div>
        <div className="text-xs text-slate-400 mt-1" data-testid="my-state">{me.state === "personal" ? "Personal — no current workplace" : "Connected"}</div>
      </div>
      <div className="rounded-2xl border bg-white p-4 space-y-2">
        <div className="font-semibold text-slate-700">My workplaces</div>
        {me.relationships.filter((r) => r.status === "active").length === 0 && <p className="text-sm text-slate-400" data-testid="my-no-workplaces">No current workplaces. You can still use My CaterCTRL.</p>}
        {me.relationships.filter((r) => r.status === "active").map((r) => (
          <div key={r.membership_id} className="flex justify-between items-center text-sm" data-testid={`my-rel-${r.membership_id}`}>
            <span>{r.org_name} <span className="text-[10px] uppercase text-slate-400 ml-1">{r.relationship}</span></span>
            <Button size="sm" variant="outline" onClick={() => open(r)} data-testid={`my-open-${r.membership_id}`}>Open</Button>
          </div>))}
        <div className="flex gap-2 pt-2"><Input placeholder="Workplace invitation code" value={token} onChange={(e) => setToken(e.target.value)} data-testid="my-invite-token" />
          <Button onClick={accept} disabled={!token} data-testid="my-invite-accept">Connect</Button></div>
      </div>
    </div>
  );
}

export default function MyCaterCTRL() {
  const { logout } = useAuth();
  const [me, setMe] = useState(null);
  const load = () => api.get("/my/me").then((r) => setMe(r.data)).catch(() => setMe(false));
  useEffect(() => { load(); }, []);
  if (me === null) return <p className="p-6 text-slate-400">Loading…</p>;
  if (me === false) return <p className="p-6 text-slate-500">My CaterCTRL is not available on this device.</p>;
  return (
    <div className="min-h-screen bg-slate-50" data-testid="my-caterctrl-page">
      <div className="max-w-4xl mx-auto p-4 space-y-4">
        <div className="flex justify-between items-center">
          <div><h1 className="text-2xl font-bold text-slate-800">My CaterCTRL</h1><p className="text-sm text-slate-500">{me.identity.name}</p></div>
          <Button variant="outline" size="sm" onClick={logout} data-testid="my-logout">Sign out</Button>
        </div>
        <Tabs defaultValue="home">
          <TabsList className="flex-wrap h-auto">
            <TabsTrigger value="home" data-testid="my-tab-home">Home</TabsTrigger>
            {MY_TABS.map((t) => <TabsTrigger key={t.key} value={t.key} data-testid={`my-tab-${t.key}`}>{t.label}</TabsTrigger>)}
          </TabsList>
          <TabsContent value="home"><Home me={me} reload={load} /></TabsContent>
          {MY_TABS.map((t) => <TabsContent key={t.key} value={t.key}><t.Component me={me} /></TabsContent>)}
        </Tabs>
      </div>
    </div>
  );
}
